import React from "react";
import useLocalStorage from "../../../hooks/useLocalStorage";

const helpDeskItems = [
  {
    name: "Activations",
    link: "https://www.idfree.com/activation"
  },
  {
    name: "FAQ",
    link: "https://www.idfree.com/faq"
  }
];
const HelpDesk = () => {
  const [showMenu, setShowMenu] = useLocalStorage("helpDesk", true);

  return (
    <div className="help_desk">
      <div
        role="button"
        tabIndex={0}
        onClick={() => setShowMenu(!showMenu)}
        className="help_desk_button"
      >
        <HelpDeskIcon />
        Help Desk
        <OpenHideIcon className={!showMenu ? "open_icon" : "close_icon"} />
      </div>

      {showMenu && (
        <ul className="helpdesk_menu">
          {helpDeskItems.map(el => (
            <li key={el.name}>
              <a href={el.link} target="_blank" rel="noreferrer noopener">
                {el.name}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default HelpDesk;

const HelpDeskIcon = props => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.0563 11.6979C22.0563 17.5125 17.3427 22.2261 11.5281 22.2261C5.71361 22.2261 1 17.5125 1 11.6979C1 5.88341 5.71361 1.1698 11.5281 1.1698C17.3427 1.1698 22.0563 5.88341 22.0563 11.6979Z"
      fill="#FEFFFF"
    />
    <path
      d="M7.11528 8.18856C7.75763 6.82553 9.49086 5.84897 11.5282 5.84897C14.1124 5.84897 16.2074 7.42018 16.2074 9.35835C16.2074 10.9954 14.7128 12.3707 12.6912 12.7585C12.0567 12.8802 11.5282 13.3915 11.5282 14.0375M11.5281 17.5469H11.5398M22.0563 11.6979C22.0563 17.5125 17.3427 22.2261 11.5281 22.2261C5.71361 22.2261 1 17.5125 1 11.6979C1 5.88341 5.71361 1.1698 11.5281 1.1698C17.3427 1.1698 22.0563 5.88341 22.0563 11.6979Z"
      stroke="#11171F"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const OpenHideIcon = props => (
  <svg
    width="14"
    height="9"
    viewBox="0 0 14 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.0801 1.20435L0.503791 6.78066C0.0299865 7.25447 0.0299865 8.01984 0.503791 8.49365C0.977595 8.96745 1.74297 8.96745 2.21677 8.49365L6.94267 3.7799L11.6564 8.49365C12.1302 8.96745 12.8956 8.96745 13.3694 8.49365C13.8432 8.01984 13.8432 7.25447 13.3694 6.78066L7.79308 1.20435C7.33143 0.730548 6.5539 0.730548 6.0801 1.20435Z"
      fill="#FEFFFF"
    />
  </svg>
);
